import React from 'react';

import { Button } from '@lt/components';
import { useTranslation } from '@lt/localization';

import { NBSP } from '../../../../../constants/common';

import type { IOrderError } from './types';

const baseCls = 'lt-error-popup';

const OrderError = ({
  title,
  errorMessage,
  partnerContactPhone,
  onClickRetry = null,
  orderNumber,
  showOrderLink = false,
  goToOrder,
}: IOrderError): JSX.Element => {
  const { t } = useTranslation();

  const contactPhone = partnerContactPhone?.length
    ? partnerContactPhone
    : '+7 495 134-44-11';

  return (
    <div className={`${baseCls}__content`}>
      <div className="lt-icon-error">
        <i className="lt-icon-error__cross" />
      </div>
      <h2 className={`${baseCls}__title`}>{title}</h2>
      <div className={`${baseCls}__message`}>
        {onClickRetry ? (
          <>
            <p>
              <strong>{t('checkout.error.possibleReasons')}</strong>
            </p>
            <p>{errorMessage}</p>
            <Button
              className={`${baseCls}__retry`}
              onClick={() => onClickRetry()}
              primary
            >
              {t('subscribe.retry')}
            </Button>
            {showOrderLink && (
              <p>
                <Button functional onClick={goToOrder} className="lt-link">
                  {t('checkout.error.goToOrder')}
                </Button>
              </p>
            )}
            <p>
              {t('checkout.error.contactUs', { context: 'withRetry' })}
              {NBSP}
              <span className="nowrap">
                {t('checkout.error.contactPhone', {
                  contactPhone,
                })}
              </span>
              <br />
              {t('checkout.error.orderNumber', {
                context: 'withRetry',
                orderNumber,
              })}
            </p>
          </>
        ) : (
          <div>
            <p>
              {t('checkout.error.orderNumber', {
                context: 'withoutRetry',
              })}
            </p>
            <p>{orderNumber}</p>
            <p>
              {t('checkout.error.contactUs', { context: 'withoutRetry' })}
              <br />
              {t('checkout.error.contactPhone', {
                contactPhone,
              })}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderError;
